import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationContextState } from './location-context.reducers';

export const locationContextState = createFeatureSelector<LocationContextState>('locationContext');

// Terminals
export const terminalsSelector = createSelector(locationContextState, locationContext => locationContext.terminals);

// Centerline Groups
export const centerlineGroupsSelector = createSelector(
    locationContextState,
    locationContext => locationContext.centerlineGroups
);

// Centerlines
export const centerlinesSelector = createSelector(locationContextState, locationContext => locationContext.centerlines);
